/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Backlog
 * 
 * 1 = ThirdParty
 * 
 * 2 = AwaitingCollection
 * 
 * 3 = GoodsIn
 * 
 * 4 = QaInspection
 * 
 * 5 = Gauging
 * 
 * 6 = ProofLoad
 * 
 * 7 = FirstStageBuild
 * 
 * 8 = Calibration
 * 
 * 9 = FinalBuild
 * 
 * 10 = PressureTest
 * 
 * 11 = FinalInspection
 * 
 * 12 = ReadyForDispatch
 * 
 * 13 = Dispatched
 */
export enum WorkOrderSwimlane {
  Backlog = 0,
  ThirdParty = 1,
  AwaitingCollection = 2,
  GoodsIn = 3,
  QaInspection = 4,
  Gauging = 5,
  ProofLoad = 6,
  FirstStageBuild = 7,
  Calibration = 8,
  FinalBuild = 9,
  PressureTest = 10,
  FinalInspection = 11,
  ReadyForDispatch = 12,
  Dispatched = 13
}
